import { booleanAttribute } from "#ce/utils/props";

export const variantOptions = ["default", "segmented"];

export const sizeOptions = ["medium", "small"];

export const props = Object.freeze({
  /**
   * Look of the tab row. `segmented` draws the tabs as pills inside a rounded rail, with the active tab raised.
   *
   * @type {String}
   * @default "default"
   * @values default, segmented
   * @storybook-control radio
   */
  variant: {
    type: String,
    default: "default",
    validator: (value) => variantOptions.includes(value),
  },
  /**
   * Height of a segmented tab: `medium` is 32px, `small` is 28px for dense surfaces such as popovers and toolbars.
   * Both sizes use `--sp-ref-font-size-semi-medium`, because Figma's 12px label size has no token.
   *
   * @type {String}
   * @default "medium"
   * @values medium, small
   * @storybook-control radio
   */
  size: {
    type: String,
    default: "medium",
    validator: (value) => sizeOptions.includes(value),
  },
  /**
   * Stretch the tab row to the group's width and share the extra space equally between the tabs. A segmented tab never
   * shrinks below its label, so a tab with a longer label can be wider than the others, and a row wider than the group
   * scrolls the rail.
   *
   * @type {Boolean|String}
   * @default false
   */
  fill: booleanAttribute(),
});
